import { render } from "./CrashGamesPage.vue?vue&type=template&id=74c1ed4d&scoped=true"
import script from "./CrashGamesPage.vue?vue&type=script&lang=js"
export * from "./CrashGamesPage.vue?vue&type=script&lang=js"

import "./CrashGamesPage.vue?vue&type=style&index=0&id=74c1ed4d&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c1ed4d"]])

export default __exports__